var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40:374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7278 3.17634L18.7904 6.01916C19.0697 6.27852 19.0701 6.72124 18.7904 6.98095L15.7278 9.82402C15.3094 10.2125 14.625 9.91633 14.625 9.34313L14.625 7.59381L7.1875 7.59381L7.1875 9.89003C7.1875 9.93312 7.17902 9.97579 7.16253 10.0156C7.14603 10.0554 7.12186 10.0916 7.09139 10.122L5.56014 11.6533C5.35345 11.86 5 11.7136 5 11.4213L5 6.06256C5 5.70012 5.29381 5.40631 5.65625 5.40631L14.625 5.40631L14.625 3.65724C14.625 3.08636 15.3077 2.78631 15.7278 3.17634Z",
    fill: "#D8D8D8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_40:374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2722 20.3237L5.20962 17.4808C4.93033 17.2215 4.92992 16.7788 5.20962 16.519L8.2722 13.676C8.69056 13.2875 9.375 13.5837 9.375 14.1569L9.375 15.9062L16.8125 15.9062L16.8125 13.61C16.8125 13.5669 16.821 13.5242 16.8375 13.4844C16.854 13.4446 16.8781 13.4084 16.9086 13.378L18.4399 11.8467C18.6466 11.64 19 11.7864 19 12.0787L19 17.4374C19 17.7999 18.7062 18.0937 18.3437 18.0937L9.375 18.0937L9.375 19.8428C9.375 20.4136 8.69225 20.7137 8.2722 20.3237Z",
    fill: "#D8D8D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40:374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.75,
    height: 14,
    fill: "white",
    transform: "translate(5 11.75) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_40:374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.75,
    height: 14,
    fill: "white",
    transform: "translate(19 11.75) rotate(90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.94bba006.svg";
export { ForwardRef as ReactComponent };